// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VacancyRequests_container__Kaa8v {
  padding: 20px;
}

.VacancyRequests_controls__bbMrB {
   display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.VacancyRequests_viewToggle__MWn6D {
  display: flex;
  gap: 10px;
}

.VacancyRequests_viewToggle__MWn6D button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}

.VacancyRequests_viewToggle__MWn6D button.VacancyRequests_active__D22CG {
  background: #007bff;
  color: white;
}

.VacancyRequests_createButton__R2REU {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.VacancyRequests_error__WQRmy {
  color: #dc3545;
  margin-bottom: 20px;
}

/* List View */
.VacancyRequests_listView__gY\\+UF {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.VacancyRequests_listHeader__AUtz- {
  display: grid;
  grid-template-columns: 80px 1fr 120px 120px;
  gap: 10px;
  font-weight: bold;
  padding: 10px;
  background: #f8f9fa;
}

.VacancyRequests_card__qiX6O {
  display: grid;
  grid-template-columns: 80px 1fr 120px 120px;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  align-items: center;
}

.VacancyRequests_actions__YsNI4 {
  display: flex;
  gap: 10px;
}

/* Kanban View */
.VacancyRequests_kanbanView__k\\+trE {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.VacancyRequests_kanbanColumn__tAXdg {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}
.VacancyRequests_kanbanColumnHeader__RuJZH {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}

.VacancyRequests_countBadge__hQrBx {
  background: #6c757d;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
}
.VacancyRequests_kanbanColumn__tAXdg h3 {
  margin-top: 0;
  text-align: center;
}

.VacancyRequests_kanbanCards__yJfDL {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.VacancyRequests_kanbanCard__vSQln {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

.VacancyRequests_kanbanCardContent__fd2e3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.VacancyRequests_kanbanCardMeta__3ZvVB {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: #666;
}

.VacancyRequests_kanbanActions__dnPpJ {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
}

.VacancyRequests_kanbanActions__dnPpJ button {
  width: 100%;
  padding: 5px;
  font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/components/VacancyRequests/VacancyRequests.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;GACG,aAAa;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".container {\n  padding: 20px;\n}\n\n.controls {\n   display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.viewToggle {\n  display: flex;\n  gap: 10px;\n}\n\n.viewToggle button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: #fff;\n  cursor: pointer;\n}\n\n.viewToggle button.active {\n  background: #007bff;\n  color: white;\n}\n\n.createButton {\n  padding: 8px 16px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.error {\n  color: #dc3545;\n  margin-bottom: 20px;\n}\n\n/* List View */\n.listView {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.listHeader {\n  display: grid;\n  grid-template-columns: 80px 1fr 120px 120px;\n  gap: 10px;\n  font-weight: bold;\n  padding: 10px;\n  background: #f8f9fa;\n}\n\n.card {\n  display: grid;\n  grid-template-columns: 80px 1fr 120px 120px;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  align-items: center;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Kanban View */\n.kanbanView {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n}\n\n.kanbanColumn {\n  background: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n}\n.kanbanColumnHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.countBadge {\n  background: #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em;\n}\n.kanbanColumn h3 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.kanbanCards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.kanbanCard {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: white;\n}\n\n.kanbanCardContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kanbanCardMeta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8em;\n  color: #666;\n}\n\n.kanbanActions {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.kanbanActions button {\n  width: 100%;\n  padding: 5px;\n  font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VacancyRequests_container__Kaa8v`,
	"controls": `VacancyRequests_controls__bbMrB`,
	"viewToggle": `VacancyRequests_viewToggle__MWn6D`,
	"active": `VacancyRequests_active__D22CG`,
	"createButton": `VacancyRequests_createButton__R2REU`,
	"error": `VacancyRequests_error__WQRmy`,
	"listView": `VacancyRequests_listView__gY+UF`,
	"listHeader": `VacancyRequests_listHeader__AUtz-`,
	"card": `VacancyRequests_card__qiX6O`,
	"actions": `VacancyRequests_actions__YsNI4`,
	"kanbanView": `VacancyRequests_kanbanView__k+trE`,
	"kanbanColumn": `VacancyRequests_kanbanColumn__tAXdg`,
	"kanbanColumnHeader": `VacancyRequests_kanbanColumnHeader__RuJZH`,
	"countBadge": `VacancyRequests_countBadge__hQrBx`,
	"kanbanCards": `VacancyRequests_kanbanCards__yJfDL`,
	"kanbanCard": `VacancyRequests_kanbanCard__vSQln`,
	"kanbanCardContent": `VacancyRequests_kanbanCardContent__fd2e3`,
	"kanbanCardMeta": `VacancyRequests_kanbanCardMeta__3ZvVB`,
	"kanbanActions": `VacancyRequests_kanbanActions__dnPpJ`
};
export default ___CSS_LOADER_EXPORT___;
